window.prefillData = function prefillData() {
  var schoolModalData = $('#school-modal-form').data('values');

  if (!schoolModalData) return;

  $('#school-select-modal input[name="school_type"]').attr('required', false);
  if (schoolModalData.nation) {
    $('#school-select-modal #nation')
      .val(schoolModalData.nation)
      .trigger('change');
  }

  if (schoolModalData.region_id) {
    fill_regions(
      $('#school-select-modal #region_id'),
      schoolModalData.region_id
    );
  }

  if (!schoolModalData.city_id) return;

  $('#school-select-modal .school-type').show();
  $('#school-select-modal .course-name').show();

  $('#city_id')
    .attr('data-id', schoolModalData.city_id)
    .val(schoolModalData.city_name);
  $('#school-select-modal #hidden_city_id').val(schoolModalData.city_id);

  if(schoolModalData.school_type){
    var selectSchoolType = $('#school-select-modal input[name="school_type"]');
    var radio_school_type = '';
    switch (schoolModalData.school_type) {
      case 'public_school':
        radio_school_type = 'public';
        $('#school-select-modal .school-details').show();
        break;
      case 'private_school':
        radio_school_type = 'private';
        $('#school-select-modal .school-details').hide();
        break;
      case 'other_school':
        radio_school_type = 'other';
        $('#school-select-modal .school-details').hide();
        break;
    }
    $('#school-select-modal input[name="school_type"][value="' + radio_school_type + '"]').prop('checked', true);
    $('#school-select-modal input[name="school_type"][value="' + radio_school_type + '"]').click();
    selectSchoolType.attr('required', true);
  }

  // if (!schoolModalData.school_code) return;

  // $('#school-select-modal .school-details').show();
  // fill_schools(
  //   $('#school-modal-form #school_code'),
  //   schoolModalData.city_id,
  //   schoolModalData.school_code
  // );
  // fill_courses($('#school-modal-form #course'), schoolModalData.school_code);
}

window.resetForm = function resetForm() {
  $('#school-select-modal #region_id').val('');
  $('#school-select-modal #city_id').val('');
  $('#school-select-modal #hidden_city_id').val('');
  $('#school-select-modal #school_code').val('').selectpicker('refresh');
  $('#school-select-modal #course').val('');
}

$(function () {

  // Check if the modal is there
  if ($('#school-select-modal').length === 0 || typeof $('#school-select-modal').modal === "undefined") return;
  // Open the modal
  var sSmodal = $('#school-select-modal').modal({ backdrop: 'static', keyboard: false, show: true });
  sSmodal.modal('show');
  // First to second step
  $('#school-modal-step1-submit').on('click', function () {
    $('#school-select-modal .step1').removeClass('active');
    $('#school-select-modal .step2').addClass('active');
    $('#school-select-modal .school-inputs').not('.school-geo-info').hide();

    set_autocomplete_city(
      $('#school-select-modal #city_id'),
      function (_event, ui) {
        var sel = $('#school-modal-form #school_code');
        sel.find('option').remove();
        $('#school-modal-form #course').find('option').remove();
        sel.selectpicker('refresh');
        fill_schools(sel, ui.item.id);
        $('#hidden_city_id').val(ui.item.id);
      }
    );
    prefillData();
  });

  $('#school-select-modal #nation').on('change', function () {
    if ($(this).val() && $(this).val().toLowerCase() === 'np') {
      $('#school-select-modal .school-inputs').hide();
      $('#school-select-modal #city_id').prop('required', false);
      $('#school-select-modal #hidden_city_id').prop('required', false);
      $('#school-select-modal #region_id').prop('required', false);
      $('#school-select-modal #region_id').prop('required', false);
      $('#school-modal-form #school_code').prop('required', false);
      $('#school-modal-form #course').prop('required', false);
      $('#school-select-modal #school-modal-form').attr('required', false);
      $('#school-select-modal input[name="school_type"]').attr('required', false);
      resetForm();
    } else {
      $('#school-select-modal .school-inputs')
        .not('.school-type')
        .not('.school-details')
        .show();
      $('#school-select-modal #city_id').prop('required', true);
      $('#school-select-modal #hidden_city_id').prop('required', true);
      $('#school-select-modal #region_id').prop('required', true);
      $('#school-modal-form #school_code').prop('required', true);
      $('#school-modal-form #course').prop('required', true);
      $('#school-select-modal input[name="school_type"]').attr('required', true);
    }
  });

  $('#school-select-modal input[name="school_type"]').on('change click', function () {
    $('#school-modal-form #school_code').prop(
      'required',
      $(this).val() === 'public'
    );
    $('#school-modal-form #course').prop(
      'required',
      $(this).val() === 'public'
    );
  });

  $('#school-select-modal #region_id').on('change', function () {
    set_autocomplete_city(
      $('#school-select-modal #city_id'),
      function (_event, ui) {
        var sel = $('#school-modal-form #school_code');
        sel.find('option').remove();
        $('#school-modal-form #course').find('option').remove();
        sel.selectpicker('refresh');
        fill_schools(sel, ui.item.id);
        $('#hidden_city_id').val(ui.item.id);
      }
    );
  });

  var schoolModalData = $('#school-modal-form').data('values');
  console.log('schoolModalData', schoolModalData);
});
